import { Cell, NonEditableCell } from '@silevis/reactgrid';
import { useTheme } from '@mui/material';
import usePlanStore from '../../../../../../../../../../../store/planStore';
import addCell from '../helpers/addCell';
import { Dataset } from '../interfaces';

const useAddWeeksRow = (cells: Cell[]) => {
  const { countryForms, selectedCountry } = usePlanStore();
  const dataset: Dataset | undefined =
    countryForms[selectedCountry!]?.offline?.tv;
  const theme = useTheme();

  const stableRows = 3;
  const stableColumns = 2;

  const weeks = dataset?.grpTable?.weeks ?? [];

  addCell({
    cells,
    rowIndex: 1,
    colIndex: 0,
    Template: NonEditableCell,
    value: 'Week number',
    sx: {
      color: theme.palette.grpTable.text.main,
      fontWeight: 500,
      fontSize: '12px',
      background: theme.palette.grpTable.background.default,
    },
  });
  addCell({
    cells,
    rowIndex: 1,
    colIndex: 1,
    Template: NonEditableCell,
    value: 'Copy length/ week (s)',
    sx: {
      color: theme.palette.grpTable.text.main,
      fontWeight: 500,
      fontSize: '12px',
      background: theme.palette.grpTable.background.default,
      textAlign: 'center',
    },
  });

  let nextWeek = weeks[1]?.weekNumber;
  let lastWeek: number | null = null;
  let colIndex = 2;
  weeks.forEach((week, index) => {
    nextWeek = weeks[index + 1]?.weekNumber;
    lastWeek = weeks[index - 1]?.weekNumber;
    colIndex = index + 2;
    if (week?.weekNumber === nextWeek) {
      addCell({
        cells,
        rowIndex: 1,
        colIndex,
        Template: NonEditableCell,
        value: `w${week.weekNumber}`,
        colSpan: 2,
        sx: {
          color: theme.palette.grpTable.text.main,
          fontWeight: 700,
          fontSize: '12px',
          background: theme.palette.grpTable.background.week,
        },
      });
    } else if (week.weekNumber !== lastWeek) {
      addCell({
        cells,
        rowIndex: 1,
        colIndex,
        Template: NonEditableCell,
        value: `w${week.weekNumber}`,
        colSpan: 1,
        sx: {
          color: theme.palette.grpTable.text.main,
          fontWeight: 700,
          fontSize: '12px',
          background: theme.palette.grpTable.background.week,
        },
      });
    }
  });

  addCell({
    cells,
    rowIndex: 1,
    colIndex: weeks.length + 2,
    Template: NonEditableCell,
    sx: {
      background: theme.palette.grpTable.background.default,
    },
  });
};

export default useAddWeeksRow;
